import '@/common/wireframe/bootstrap-wireframe-login'
import '@/common/the-bot/wireframe'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './AppInputPage.vue'
import BaseIcon from '@/components/common/icons/BaseIcon.vue'
import filters from '@/application/filters/index.js'
import { errorTrackingPlugin } from '@/application/utilities/error/error-plugin.js'
import '@/assets/scss/app.scss'

// makes the page reload to fix the back cache on safari browser. See SC-1105
(function () {
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload()
    }
  }
})()

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)
app.component('BaseIcon', BaseIcon)
app.config.globalProperties.$filters = filters

app.use(errorTrackingPlugin, { pinia })

app.mount('#c24es-app')
